import { ThemeOptions } from '@mui/material';

export const createTypography = (): Pick<ThemeOptions, 'typography'> => ({
  typography: {
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: ['"PT Root UI"', '"Segoe UI"', 'sans-serif'].join(', '),

    h1: { fontWeight: 400, fontSize: '46px', lineHeight: '56px' },
    h2: { fontWeight: 400, fontSize: '32px', lineHeight: '40px' },
    h3: { fontWeight: 400, fontSize: '26px', lineHeight: '32px' },
    h4: { fontWeight: 400, fontSize: '22px', lineHeight: '26px' },
    h5: { fontWeight: 500, fontSize: '18px', lineHeight: '24px' },
    h6: { fontWeight: 500, fontSize: '16px', lineHeight: '22px' },

    t1: { fontWeight: 400, fontSize: '16px', lineHeight: '22px' },
    t2: { fontWeight: 400, fontSize: '14px', lineHeight: '20px' },
    t3: { fontWeight: 400, fontSize: '12px', lineHeight: '16px' },
    t4: { fontWeight: 500, fontSize: '10px', lineHeight: '14px' },

    b1: { fontWeight: 500, fontSize: '16px', lineHeight: '22px' },
    b2: { fontWeight: 500, fontSize: '12px', lineHeight: '16px' },
  },
});
